import { render, staticRenderFns } from "./MelosCover.vue?vue&type=template&id=2b11027c&"
import script from "./MelosCover.vue?vue&type=script&lang=ts&"
export * from "./MelosCover.vue?vue&type=script&lang=ts&"
import style0 from "./MelosCover.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports